import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MessageModal = ({
  message = "",
  onClose,
  leftIcon,
  rightIcon,
  fontSize,
  color = "",
}) => {
  return (
    <div className="message-modal">
      <div className="message-overlay"></div>
      <div className="message-modal-header">
        <FontAwesomeIcon icon={leftIcon} color={color} fontSize={fontSize} />
        <p>{message}</p>
        <button className="message-close-modal" onClick={onClose}>
          <FontAwesomeIcon icon={rightIcon} />
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
